import { useHistory } from "react-router-dom";
import { Box } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { useSearchParams } from "../../hooks/useSearchParams";
import { useCustomPaginationStyles } from "./styles";

type CustomPaginationProps = {
  count?: number;
  page?: number;
  totalPages?: number;
}

export default function CustomPagination(props: CustomPaginationProps): JSX.Element {
  const history = useHistory();
  const searchParams = useSearchParams();
  const { classes } = useCustomPaginationStyles();

  function handleChange(_, page: number) {
    const newSearchParams = new URLSearchParams({
      ...Object.fromEntries(searchParams.entries()),
      page: page.toString(),
    });

    history.replace({
      pathname: window.location.pathname,
      search: newSearchParams.toString(),
    });
  }

  if (!props?.count || props?.count <= 0) {
    return <Box className={classes.main} />;
  }

  return (
    <Box className={classes.main}>
      <Pagination
        color="primary"
        count={props?.totalPages || 0}
        page={props?.page || 1}
        onChange={handleChange}
      />
    </Box>
  );
}
